import '../firebase';
import { getApp } from 'firebase/app';
import { getFunctions, httpsCallable } from 'firebase/functions';

const REGION = 'us-central1';

function getPairingFunctions() {
  return getFunctions(getApp(), REGION);
}

function callableErrorMessage(err) {
  const code = err?.code ? String(err.code) : '';
  const message = err?.message || 'Pairing key request failed';
  if (code && !message.includes(code)) {
    return `${message} (${code})`;
  }
  return message;
}

export async function ensureLiveStreamPairingKey(uid) {
  if (!uid) throw new Error('Sign in required');
  const fn = httpsCallable(getPairingFunctions(), 'liveStreamEnsurePairingKey');
  try {
    const { data } = await fn();
    const code = data?.code;
    if (typeof code !== 'string' || code.length < 6) {
      throw new Error('Invalid pairing key response');
    }
    return code;
  } catch (err) {
    throw new Error(callableErrorMessage(err));
  }
}

export async function regenerateLiveStreamPairingKey(uid) {
  if (!uid) throw new Error('Sign in required');
  const fn = httpsCallable(getPairingFunctions(), 'liveStreamRegeneratePairingKey');
  try {
    const { data } = await fn();
    const code = data?.code;
    if (typeof code !== 'string' || code.length < 6) {
      throw new Error('Invalid pairing key response');
    }
    return code;
  } catch (err) {
    throw new Error(callableErrorMessage(err));
  }
}
